var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.9995,
    cy: 54.9995,
    r: 54.9995,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.9995,
    cy: 54.9995,
    r: 54.9995,
    fill: "#9B83CB",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3049 38.9589H68.1474V79.0002H33V38.9589H41.8425",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4745 34.448V33.3914C55.4745 32.1123 53.9174 31 51.9153 31H49.2459C47.2994 31 45.6866 32.0566 45.6866 33.3914V34.448C43.4065 35.171 41.8494 36.7281 41.8494 38.5634V41.5109H59.3118V38.5634C59.3118 36.7281 57.7547 35.171 55.4745 34.448Z",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9613 34.8864C51.9613 35.665 51.3496 36.2767 50.571 36.2767C49.7924 36.2767 49.1807 35.665 49.1807 34.8864C49.1807 34.1078 49.7924 33.4961 50.571 33.4961C51.3496 33.4961 51.9613 34.1078 51.9613 34.8864Z",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.804 41.5078H36.3857V75.6542H64.804V41.5078Z",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4092 45.9592H40.3484V51.02H45.4092V45.9592Z",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4092 55.7512H40.3484V60.812H45.4092V55.7512Z",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4094 65.5947H40.3486V70.6555H45.4094V65.5947Z",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.123 45.959H60.8007",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.123 50.9678H60.8007",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.123 56.0303H60.8007",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.123 61.0908H60.8007",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.123 66.1533H60.8007",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.123 71.2139H60.8007",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8494 57.6443L43.0172 58.8122L46.8545 54.1963",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8496 67.3152L43.0175 68.4831L46.8548 63.8672",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8494 47.909L43.0172 49.0769L46.8545 44.4054",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7094 67.2533H77.6034L78.1595 46.3428H72.0977L72.7094 67.2533Z",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.488 42.7295H76.7692C77.5477 42.7295 78.1595 43.3412 78.1595 44.1198V46.3999H72.0977V44.1198C72.0977 43.3412 72.765 42.7295 73.488 42.7295Z",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.71 67.2549L74.5452 73.6504C74.712 74.2621 75.6574 74.2621 75.8243 73.6504L77.6595 67.2549H72.71Z",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9857 49.4141H72.2576",
    stroke: "#9B83CB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.3e1729afb69c4cab09e960dd4e6536af.svg";
export { ForwardRef as ReactComponent };